import { Injectable } from "@angular/core";
import { RxApiService } from "../../../core/communication/http/rx-api.service";
import { Observable } from "rxjs";
import {ApiResponseResultBundle} from "../../../core/types";

@Injectable()
export class RecordingService {
    constructor(private rxApi: RxApiService) {}

    public list(appId: string, issueId: string, qs?: any): Observable<any> {
        return this.rxApi.get(["apps", appId, "issues", issueId, "recordings"], qs);
    }

    public get(appId: string, issueId: string, id: string, qs?: any): Observable<ApiResponseResultBundle> {
        let path = ["issues", issueId, "recordings", id];

        if (appId) {
            path = ["apps", appId].concat(path);
        }

        return this.rxApi.get(path, qs, {});
    }

    public update(appId: string, issueId: string, rec: any): Observable<any> {
        return this.rxApi.patch(["apps", appId, "issues", issueId, "recordings", rec._id], {}, rec);
    }

    public remove(appId: string, issueId: string, recId: string): Observable<any> {
        return this.rxApi.remove(["apps", appId, "issues", issueId, "recordings", recId]);
    }

    public listComments(appId: string, issueId: string, qs?: any): Observable<any> {
        return this.rxApi.get(["apps", appId, "issues", issueId, "comments"], qs);
    }

    public createComment(appId: string, issueId: string, comment: any): Observable<any> {
        return this.rxApi.post(["apps", appId, "issues", issueId, "comments"], {}, comment);
    }

    public updateComment(
        appId: string,
        issueId: string,
        commentId: string,
        comment: any
    ): Observable<any> {
        return this.rxApi.patch(
            ["apps", appId, "issues", issueId, "comments", commentId],
            {},
            comment
        );
    }

    public removeComment(appId: string, issueId: string, commentId: string): Observable<any> {
        return this.rxApi.remove(["apps", appId, "issues", issueId, "comments", commentId]);
    }
}
